import React, { ReactElement, useEffect, useState } from 'react'

import PageHeader from '@instabox/internal-web-ui/components/PageHeader'
import Table from '@instabox/internal-web-ui/components/Table'
import { Device } from '@instabox/lockers-update-common/types'

import fetch from '../../fetch'

function NoAgentDevicesTable(): ReactElement {
  const [devices, setDevices] = useState<Device[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getDevices = async (context: { shouldLoad: boolean; cancel: boolean }): Promise<void> => {
    setLoading(context.shouldLoad)

    try {
      const response = await fetch('/api/device/without-update-agent')

      if (!response.ok) {
        throw new Error(`Unable to get packages: ${response.status} ${response.statusText}`)
      }

      const data = await response.json()

      if (context.cancel) {
        return
      }

      setDevices(data)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    const context = {
      shouldLoad: true,
      cancel: false,
    }

    getDevices(context).catch(console.error)

    return () => {
      context.cancel = true
    }
  }, [])

  return (
    <div>
      <PageHeader title={`Devices without update agent (${devices.length})`} size="md" tag="h2" />
      <Table
        isLoading={loading}
        headers={{
          dummy: '',
          deviceName: 'Device Name',
          deviceId: 'Device Id',
        }}
        rows={devices.map((device) => ({
          ...device,
          dummy: '',
          disableCheckbox: true,
        }))}
      />
    </div>
  )
}

export default NoAgentDevicesTable
